import classNames from 'classnames'
import { useOnce } from '@opallabs/lambda'
import { singleSelectClasses } from '../componentClassNames'
import { useSingleSelectState } from '../contexts'
import * as styles from './styles'

type LabelProps = {
  className?: string
  label: string
}

export const Label: React.FC<LabelProps> = ({ className, label }) => {
  const { getLabelProps, setHasLabel } = useSingleSelectState()

  useOnce(() => setHasLabel(true))

  return (
    <label
      css={styles.inputLabel}
      {...getLabelProps({
        className: classNames([singleSelectClasses.label, className]),
      })}
    >
      {label}
    </label>
  )
}
Label.displayName = 'Lapidary: Label ← SingleSelect'
